const call_emergency = `Hello, I am currently experiencing severe chest pain and need immediate medical assistance. 
I live near the public school.
I also fell down and my leg is bleeding.
Please send an ambulance as soon as possible. Thank you`;

export default call_emergency;